<section class="location-modal">
  <header class="location-modal-header">
    <mat-icon (click)="onClose()"> chevron_left </mat-icon>
    <div class="location-modal-title">
      @if (data.isEdit) {
        Edit Location
      } @else {
        Add Location
      }
    </div>

    <button class="white-button">
      <mat-icon>link</mat-icon>
      Add Link
    </button>
    <label for="pdf-upload">
      <div class="white-button">
        <mat-icon>article</mat-icon>
        Upload PDF
      </div>
    </label>
    <input
      id="pdf-upload"
      name="pdf-upload"
      class="d-none"
      type="file"
      accept=".pdf"
      (change)="pdfUpload($event)"
    />
  </header>

  <div class="location-modal-wrapper">
    <div class="location-modal-image-wrapper">
      <app-profile-image
        [defaultImage]="{
          image: data?.locationData?.image || '',
          type: 'location',
        }"
        [profileName]="data?.locationData?.location_name || ''"
        #locationImageComponent
      ></app-profile-image>
    </div>
    <app-location-form [formData]="data.locationData" #locationFormComponent>
    </app-location-form>

    @if (data.locationData?.pdf_name) {
      <div class="d-flex align-items-center location-modal-pdf">
        <mat-icon svgIcon="app_file"></mat-icon>
        <span class="mr-4 ml-2">{{ data.locationData.pdf_name }}</span>
        <mat-icon class="cursor-pointer" (click)="removePdf()">clear</mat-icon>
      </div>
    }
  </div>
  <div
    class="py-3 location-modal-btn d-flex align-items-center justify-content-center"
  >
    <button
      mat-button
      class="button-primary location-modal-save d-flex align-items-center justify-content-center"
      (click)="saveData()"
    >
      Save
    </button>
  </div>
</section>
